import { useRef, useEffect } from "react";

const useQueuedFilterParams = (fanFilter, updateFanFilter) => {
  const paramsRef = useRef(fanFilter.filter_params);
  const pendingSaves = useRef(0);

  const filterId = useRef(fanFilter.id);

  useEffect(() => {
    if (filterId.current !== fanFilter.id) {
      filterId.current = fanFilter.id;
      pendingSaves.current = 0;
      paramsRef.current = fanFilter.filter_params;
    } else if (pendingSaves.current === 0) {
      paramsRef.current = fanFilter.filter_params;
    }
  }, [fanFilter.id, fanFilter.filter_params]);

  const update = (changes) => {
    paramsRef.current = { ...paramsRef.current, ...changes };
    const savedFilterId = filterId.current;
    pendingSaves.current += 1;
    Promise.resolve(updateFanFilter({ filter_params: paramsRef.current }))
      .finally(() => {
        if (filterId.current === savedFilterId) pendingSaves.current -= 1;
      });
  };

  const commitText = (key, value) => {
    if (value !== String(paramsRef.current[key] ?? "")) {
      update({ [key]: value });
    }
  };

  return { params: fanFilter.filter_params, update, commitText };
};

export default useQueuedFilterParams;
